import BugsnagError, { Metadata } from './bugsnagError'

export default class DateFormatError extends BugsnagError {
  public date: string
  public format: string

  constructor(message: string, date: string, format: string) {
    super(`${message} | Date: "${date}", format: "${format}"`)

    this.name = 'DateFormatError'
    this.date = date
    this.format = format
  }

  getMetadata(): Metadata {
    return {
      details: {
        date: this.date,
        format: this.format
      }
    }
  }
}
